import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export default [
  {
    prop: "EmployeeCode",
    name: "EmployeeCode",
    label: "Código de Empleado",
    width: 200,
    sortable: true
  },
  {
    prop: "EmployeeName",
    name: "EmployeeName",
    label: "Nombre",
    width: 200,
    sortable: true
  },
  {
    prop: "EmployeeLastName",
    name: "EmployeeLastName",
    label: "Apellido",
    width: 200,
    sortable: true
  },
  {
    prop: "EmployeeEmail",
    name: "EmployeeEmail",
    label: "E-Mail",
    minWidth: 300,
    sortable: true
  },
  {
    prop: "EmployeeBirthday",
    name: "EmployeeBirthday",
    label: "Cumpleaños",
    formatter: DatetimeFormatter,
    width: 200,
    sortable: true
  }
];
